import {Injectable} from '@angular/core';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class VerifyExportDownloadService {
    constructor(public secureApi: SecureApi) {
    }

    verifyDownload(id, token) {
        let url = 'retrieve-data/download/' + id + '/' + token;
        return this.secureApi.downloadFile(url);
    }
}
